import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LayoutProps {
  email: string;
  isAdmin: boolean;
  onSignOut: () => void;
  children: ReactNode;
}

export function Layout({ email, isAdmin, onSignOut, children }: LayoutProps): JSX.Element {
  const location = useLocation();
  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">Benilar ProServ Access</div>
        <nav>
          <Link className={location.pathname === '/' ? 'active' : ''} to="/">
            My access
          </Link>
          {isAdmin && (
            <Link className={location.pathname === '/admin' ? 'active' : ''} to="/admin">
              Admin
            </Link>
          )}
        </nav>
        <div className="user">
          <span>{email}</span>
          <button onClick={onSignOut}>Sign out</button>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
